import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

export function ComponentShowcase({ title, description, children, className = '' }) {
  return (
    <Card className={`mt-6 ${className}`}>
      <CardHeader>
        <CardTitle className="text-lg">{title}</CardTitle>
        {description && (
          <CardDescription>{description}</CardDescription>
        )}
      </CardHeader>
      <CardContent>
        <div className="flex flex-wrap items-center gap-4">
          {children}
        </div>
      </CardContent>
    </Card>
  )
}
